<template>
  <modal-wrapper :shown="settingsModalShown" @hide="hideSettingsModal">
    <div class="px-4 text-lg font-bold">Settings</div>
    <div
      v-for="settingGroup in settingGroups"
      :key="settingGroup.label"
      v-show="!settingGroup.hide"
    >
      <div class="px-4 mt-6 text-sm font-bold">
        {{ settingGroup.label }}
      </div>
      <setting-toggle
        v-for="option in settingGroup.settings"
        :key="option.id"
        :option="option"
      />
    </div>
    <div class="px-4 mt-6">
      <action-button @click="hideSettingsModal" type="outline">
        Close
      </action-button>
    </div>
  </modal-wrapper>
</template>

<script>
import { call, get } from "vuex-pathify";

import ModalWrapper from "@/components/ModalWrapper";
import SettingToggle from "@/components/SettingToggle";
import ActionButton from "@/components/inputs/ActionButton";

export default {
  components: {
    ModalWrapper,
    SettingToggle,
    ActionButton,
  },
  watch: {
    wakeLock(value) {
      let wakeLock = null;
      if (value === true) {
        if ("wakeLock" in navigator) {
          try {
            wakeLock = navigator.wakeLock.request("screen");
            alert("turned on wakelock");
          } catch (err) {
            console.log(err);
          }
        }
      } else {
        if ("wakeLock" in navigator) {
          wakeLock.release().then(() => {
            wakeLock = null;
          });
        }
      }
    },
  },
  computed: {
    settingsModalShown: get("settingsModalShown"),
    settingGroups() {
      return [
        {
          label: "Device",
          hide: !("wakeLock" in navigator),
          settings: [
            {
              id: "wakeLock",
              title: "Keep device awake when Dobble is open",
              value: this.wakeLock,
            },
          ],
        },
        {
          label: "Theme",
          settings: [
            {
              id: "darkMode",
              title: "Dark mode",
              value: this.darkMode,
            },
          ],
        },
        {
          label: "Rolling",
          settings: [
            {
              id: "highlightMinAndMaxRolls",
              title: "Highlight min and max rolls",
              value: this.highlightMinAndMaxRolls,
            },
            {
              id: "showFavoritesGroupNameInLog",
              title: "Show favorites group name in log",
              value: this.showFavoritesGroupNameInLog,
            },
          ],
        },
      ];
    },
    wakeLock: get("wakeLock"),
    darkMode: get("darkMode"),
    highlightMinAndMaxRolls: get("highlightMinAndMaxRolls"),
    showFavoritesGroupNameInLog: get("showFavoritesGroupNameInLog"),
  },
  methods: {
    hideSettingsModal: call("hideSettingsModal"),
  },
};
</script>
